export default "__VITE_ASSET__e8ce7679__"